import React from "react";
import "./TableButtons.css";

/**
 * SaveRowButton - Checkmark button for saving inline table edits
 *
 * @param {boolean} props.loading - When true, shows a spinner and disables the button
 * @example
 * <SaveRowButton onClick={handleSave} disabled={!isValid} loading={isSaving} />
 */
const SaveRowButton = ({ onClick, disabled = false, loading = false, ariaLabel = "Save row", ...props }) => {
  return (
    <button
      className="save-row"
      onClick={onClick}
      disabled={disabled || loading}
      aria-label={ariaLabel}
      title="Save"
      {...props}
    >
      {loading ? <span className="table-btn-spinner" /> : "✔"}
    </button>
  );
};

export default SaveRowButton;

